const en = {
  i18nView: {
    activitionCode: 'Account Activation Code',
    payment: 'Payment',
    alipay: 'Alipay',
    weipay: 'WeChat',
    reciveMethod: 'Receive code through',
    phone: 'Phone',
    email: 'Email',
    emailholder: 'E-mail address',
    phoneholder: 'Phone number',
    paynow: 'Pay Now',
    moreOptions: 'More Options (Click to pay)',
    optionOne: 'Option 1',
    optionTwo: 'Option 2',
    optionTips: 'Option 1 & 2 have more RAM in the account',
    accountTips: '*The account include 4 KB of RAM, 0.01',
    accountTips2: ' of NET + 0.5 ',
    accountTips3: '(staked for 30 days) of CPU and 0.001 ',
    accountTips4: 'for balance',
    copyCode: 'Click to Copy',
    download: 'Download',
    buyAgain: 'Repurchase',
    noPay: 'No pay',
    whypaid: 'Why it\'s a paid service?',
    paused: 'Service is under maintaince'
  }
};

export default en;